module.exports = __webpack_public_path__ + "assets/img/riaan_boshoff.0b314b80.png";